import { useCallback, useEffect, useState } from "react";
import { applyApprovedHandover, fetchHandover, saveLineAddresses, submitHandover } from "../../models/handover/handoverModel";

export function useOperationsHandover(queryPk) {
  const [projection, setProjection] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    if (!queryPk) { setProjection(null); return null; }
    setLoading(true);
    setError(null);
    try {
      const result = await fetchHandover(queryPk);
      setProjection(result);
      return result;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [queryPk]);

  useEffect(() => { reload().catch(() => {}); }, [reload]);

  const saveAddresses = useCallback(async (selections) => {
    setSaving(true);
    try {
      const result = await saveLineAddresses(queryPk, selections);
      setProjection(result);
      return result;
    } finally { setSaving(false); }
  }, [queryPk]);

  const handover = useCallback(async (payload) => {
    setSaving(true);
    try {
      const result = await submitHandover({ query_pk: queryPk, ...payload });
      await reload();
      return result;
    } finally { setSaving(false); }
  }, [queryPk, reload]);

  const applyApproved = useCallback(async (handoverId) => {
    setSaving(true);
    try {
      const result = await applyApprovedHandover(handoverId);
      await reload();
      return result;
    } finally { setSaving(false); }
  }, [reload]);

  return { projection, loading, saving, error, reload, saveAddresses, handover, applyApproved };
}
